import {
  getCsvConfigGeneralOcr as getCsvConfigApi,
  saveCsvConfig,
  CsvConfigGeneralOcr,
} from 'api/csv'
import DialogBase from 'components/dialog/Base'
import FormInput from 'components/ui/FormInput'
import { DOC_TYPE, ERROR_TEXT } from 'config'
import { useAlert } from 'hooks/useDialog'
import { useState, useEffect, useCallback } from 'react'
import { useForm, FormProvider } from 'react-hook-form'

type Props = {
  open: boolean
  actionText?: string
  onClose: (canceled: boolean) => void
}

const CONFIG_KEY_PREFIX = 'generalOCR'

const types = [
  { k: 'zipExcel', l: 'Excel', testid: 'zip-excel' },
  { k: 'zipCsv', l: 'CSV', testid: 'zip-csv' },
  { k: 'zipText', l: 'Text', testid: 'zip-text' },
  { k: 'zipJson', l: 'JSON', testid: 'zip-json' },
].map((i) => ({ k: `${CONFIG_KEY_PREFIX}.${i.k}`, l: i.l, testid: i.testid }))

const GeneralOcrCsvConfigDialog = ({ open, onClose }: Props) => {
  const alert = useAlert()

  const [csvConfig, setCsvConfig] = useState<CsvConfigGeneralOcr | null>(null)
  const { reset: formReset, ...form } = useForm<CsvConfigGeneralOcr>()
  const [loading, setLoading] = useState(false)

  const doGetCsvConfig = useCallback(async () => {
    try {
      setCsvConfig(await getCsvConfigApi())
    } catch {
      alert({ message: '設定取得に失敗しました' })
      onClose(true)
    }
  }, [alert, onClose])

  useEffect(() => {
    if (open) {
      doGetCsvConfig()
    } else {
      setCsvConfig(null)
    }
  }, [open, doGetCsvConfig])

  useEffect(() => {
    if (csvConfig !== null) formReset(csvConfig)
  }, [csvConfig, formReset])

  const submit = form.handleSubmit(async (data) => {
    if (types.every(({ k }) => !data.generalOCR[k.split('.')[1]])) {
      return alert({ message: ERROR_TEXT.csvSelectZero })
    }
    setLoading(true)
    try {
      await saveCsvConfig(DOC_TYPE.GENERAL_OCR, undefined, undefined, data)
    } catch (err) {
      await alert({ message: '設定格納に失敗しました' })
      return onClose(true)
    }
    onClose(false)
    setLoading(false)
  })

  return (
    <DialogBase
      open={open}
      loading={!csvConfig || loading}
      title="出力設定: テキスト・表"
      onCancel={() => onClose(true)}
      onClose={() => onClose(true)}
      onAction={submit}
      actionText="設定"
      cancelText="キャンセル"
      actionProps={{ disabled: Boolean(false) }}
    >
      <FormProvider {...form} reset={formReset}>
        <fieldset>
          <legend>ZIP内に含まれるファイル</legend>
          {types.map(({ k: t, l, testid }) => (
            <FormInput key={t} name={t} type="checkbox" label={l} testid={testid} />
          ))}
        </fieldset>
        <FormInput type="hidden" name="dialogDisp" label="dialogDisp" />
        <FormInput type="hidden" name="header" label="header" />
      </FormProvider>
    </DialogBase>
  )
}

export default GeneralOcrCsvConfigDialog
